import { ApolloLink, fromPromise } from '@apollo/client';
import { onError } from '@apollo/client/link/error';
import { refreshAccessToken } from './tokenRefreshService';

// Fix B9: la logica refresh (chiamata server + singleton lock) e ora in
// `tokenRefreshService.ts`, condivisa con `axiosInstance.ts` (REST). Prima
// ogni layer aveva il proprio `isRefreshing` locale: refresh paralleli
// concorrenti invalidavano il refresh token a vicenda e l'utente veniva
// sloggato. Ora entrambi i layer attendono lo stesso singleton promise.

// Error link per gestire errori di autenticazione
export const errorLink = onError(({ graphQLErrors, operation, forward }) => {
  if (graphQLErrors) {
    for (const err of graphQLErrors) {
      if (
        err.extensions?.code === 'UNAUTHENTICATED' ||
        err.message.includes('Token expired') ||
        err.message.includes('Unauthorized') ||
        err.message.includes('Authentication required')
      ) {
        return fromPromise(
          refreshAccessToken()
            .then((accessToken) => {
              operation.setContext({
                headers: {
                  ...operation.getContext().headers,
                  authorization: `Bearer ${accessToken}`,
                },
              });
              return accessToken;
            })
            .catch((error) => {
              // Il service ha gia rimosso i token da localStorage.
              // Redirect a /login (pubblico) solo se non siamo gia li.
              if (!window.location.pathname.includes('/login')) {
                window.location.href = '/login';
              }
              throw error;
            })
        ).flatMap(() => forward(operation));
      }
    }
  }
});

// Auth link per aggiungere il token a ogni richiesta
export const authLink = new ApolloLink((operation, forward) => {
  const token = localStorage.getItem('accessToken');

  operation.setContext({
    headers: {
      ...operation.getContext().headers,
      authorization: token ? `Bearer ${token}` : '',
    },
  });

  return forward(operation);
});

